export default {"src":"/_next/static/media/message-us-regular.054f9d92.svg","height":75,"width":169};